module.exports = __webpack_public_path__ + "img/make_pc_03.570040e7.png";